import React from 'react';
import './App.css';
import {BrowserRouter, Navigate, Route, Routes} from "react-router";
import {BaseLayout} from "./BaseLayout";
import {AdminDashboard} from "./Pages/Admin/AdminDashboard";
import {AdminVersions} from "./Pages/Admin/AdminVersions";
import {Versions} from "./Pages/User/Versions";
import {AdminHostSystems} from "./Pages/Admin/AdminHostSystem";
import {AdminFileTypes} from "./Pages/Admin/AdminFileType";
import {useApplicationContext} from "./ApplicationContext";
import {SignInSide} from "./Pages/Public/SignIn";
import {AdminUsers} from "./Pages/Admin/AdminUsers";
import {AdminUserDetail} from "./Pages/Admin/AdminUserDetail";
import {AdminSupportContracts} from "./Pages/Admin/AdminSupportContracts";
import {QuickSupport} from "./Pages/QuickSupport/QuickSupport";
import {NotFound} from "./Pages/Public/NotFound";
import {ServiceCodeNew} from "./Pages/Admin/ServiceCodeNew";
import {AcceptTerms} from "./Pages/User/AcceptTerms";
import {AdminTerms} from "./Pages/Admin/AdminTerms";
import {ChangePassword} from "./Pages/User/ChangePassword";
import {MfaVerify} from "./Pages/Public/MfaVerify";
import {SecuritySettings} from "./Pages/User/SecuritySettings";
import {MfaRequiredGate} from "./Pages/User/MfaRequiredGate";
import {EUserGroup} from "./apiClient/Api";
import {FilterTags} from "./Pages/Admin/FilterTags";
import {ServiceCode} from "./Pages/Admin/ServiceCode";
import {SignUp} from "./Pages/Public/SignUp";
import {HostDown} from "./Pages/Public/HostDown";
import {CoreDumpData} from "./Pages/Admin/CoreDumps/CoreDumpData";
import {CoreDumpsList} from "./Pages/Admin/CoreDumps/CoreDumpsList";
import CoreDumpUpload from "./Pages/Admin/CoreDumps/CoreDumpUpload";
import FileTypeEdit from "./Pages/Admin/FileTypeEdit";
import DeviceManagement from './Pages/User/DeviceManagement';
import DeviceLicensePage from './Pages/User/DeviceLicensePage';
import { Applications } from 'Pages/User/Applications';
import { ApplicationSingle } from 'Pages/User/ApplicationSingle';
import { LicenseGenerator } from 'Pages/Admin/LicenseGenerator';
import GeodataConverter from 'Pages/Admin/GeodataConverter';
import { LicenseRequest } from 'Pages/LicenseRequest';
import AdminRequestedLicenses from 'Pages/Admin/AdminRequestedLicenses';
import AdminRequestedLicensesNew from 'Pages/Admin/AdminRequestedLicensesNew';
import LicenseRequests from 'Pages/LicenseOverview';
import { AdminAuditLog } from 'Pages/Admin/AdminAuditLog';
import FileSharing from 'Pages/User/FileSharing';
import MyTickets from './Pages/User/MyTickets';
import TicketDetails from './Pages/User/TicketDetails';
import { SupportContracts } from './Pages/User/SupportContracts';
import ProductExamplesList from './Pages/Admin/ProductExamples/ProductExamplesList';
import ProductExampleEdit from './Pages/Admin/ProductExamples/ProductExampleEdit';
import ProductExampleView from './Pages/Admin/ProductExamples/ProductExampleView';
import UnifiedSearch from './Pages/Service/UnifiedSearch';
import ApiKeys from './Pages/User/ApiKeys/ApiKeys';
import RegistrationAcknowledge from './Pages/User/RegistrationAcknowledge';
import AdminRegistrationFollowUps from './Pages/Admin/AdminRegistrationFollowUps';
import { Calculation } from './Pages/Calculation/Calculation';
import { MyCalculations } from './Pages/Calculation/MyCalculations';
import { MasterDataEditor } from './Pages/Calculation/MasterDataEditor';
import { PermissionGroups } from './Pages/Admin/PermissionGroups';
import { LdapSettings } from './Pages/Admin/LdapSettings';
import { GeocodingSettings } from './Pages/Admin/GeocodingSettings';
import { PublicConfigurator } from './Pages/Calculation/PublicConfigurator';
import { MyCalendar } from './Pages/Calendar/MyCalendar';
import { AdminSettingsLayout } from './Pages/Admin/Settings/AdminSettingsLayout';
import { SettingsOverview } from './Pages/Admin/Settings/SettingsOverview';
import { AiSettings } from './Pages/Admin/Settings/AiSettings';
import { LabelConnectSettings } from './Pages/Admin/Settings/LabelConnectSettings';
import { O365Settings } from './Pages/Admin/Settings/O365Settings';
import { Planner } from './Pages/Calendar/Planner';
import { LegacyFileTypeRedirect } from './Pages/Admin/Settings/LegacyFileTypeRedirect';
import { loader } from '@monaco-editor/react';

// Configure Monaco Editor
loader.config({
  paths: {
    vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.33.0/min/vs'
  }
});

function App() {
    const context = useApplicationContext();

    // Öffentlicher Konfigurator: eigene, nicht eingeloggte Route (Session-Token statt App-Login).
    if (window.location.pathname.startsWith('/konfigurator/')) {
        return <BrowserRouter>
            <Routes>
                <Route path="/konfigurator/:token" element={<PublicConfigurator/>}/>
            </Routes>
        </BrowserRouter>
    }

    if(context.networkError){
        return <BrowserRouter>
            <Routes>
                <Route path="*" element={<HostDown/>}/>
            </Routes>
        </BrowserRouter>
    }


    if (context.mfaPending) {
        return <MfaVerify/>;
    }

    return (
       <>
           {context.needChangePassword ? <ChangePassword /> :
            context.signInState && context.mfaSetupRequired ? <MfaRequiredGate/> :
            context.signInState && context.displayAcceptTerms ? <AcceptTerms/> : <>
                <BrowserRouter>

                    {context.signInState && context.userData !== undefined ? <>
                        <Routes>
                            <Route path="/" element={<BaseLayout/>}>
                                <Route path="" element={<AdminDashboard/>}/>
                                <Route path={"quicksupport/:id"} element={<QuickSupport/>}/>
                                <Route path="versions/:link" element={<Versions/>}/>
                                <Route path="terms" element={<AdminTerms/>}/>
                                <Route path="deviceManagement" element={<DeviceManagement/>}/>
                                <Route path="deviceManagement/:supportId" element={<DeviceManagement/>}/>
                                <Route path="device/:deviceId" element={<DeviceLicensePage/>}/>
                                <Route path="fileshare" element={<FileSharing/>}/>   
                                <Route path="fileshare/:supportContractId" element={<FileSharing/>}/>              
                                <Route path="licenses" element={<LicenseRequests/>}/>
                                <Route path="licenses/requested" element={<AdminRequestedLicensesNew/>}/>
                                <Route path="licenses/:supportId" element={<LicenseRequests/>}/>                                
                                <Route path="licenses/:supportId/request" element={<LicenseRequest/>}/>
                                <Route path="support-contracts" element={<SupportContracts/>}/>
                                <Route path="tickets" element={<MyTickets/>}/>
                                <Route path="tickets/:ticketId" element={<TicketDetails/>}/>
                                <Route path="security" element={<SecuritySettings/>}/>
                                {context.userData!.userGroup! <= EUserGroup.ADMIN &&
                                    <Route path="planer" element={<Planner/>}/>}
                                <Route path="registration/acknowledge/:token" element={<RegistrationAcknowledge/>}/>
                                <Route path="applications/:link" element={<Applications/>}/>
                                <Route path="applications/:link/:application" element={<ApplicationSingle/>}/>

                                <Route path="quicksupport" element={<QuickSupport/>}/>
                                {context.userData!.userGroup! > EUserGroup.DEVELOPMENT &&   <Route path="support" element={<QuickSupport/>}/>}
                                {context.userData!.userGroup! <= EUserGroup.DEVELOPMENT && <Route path="support" element={<ServiceCode/>}/>}
                                {context.userData!.userGroup! <= EUserGroup.OFFICE  &&
                                    <Route path="admin">
                                        <Route path="support-contracts" element={<AdminSupportContracts/>}/>
                                        <Route path="support-contracts/:supportContractId" element={<AdminSupportContracts/>}/>
                                        <Route path="coredumps" element={<CoreDumpsList/>}/>
                                        <Route path="coredumps/upload" element={<CoreDumpUpload/>}/>
                                        <Route path="coredumps/:id" element={<CoreDumpData/>}/>
                                        <Route path="users" element={<AdminUsers/>}/>
                                        <Route path="users/:id" element={<AdminUserDetail/>}/>
                                        <Route path="registrations" element={<AdminRegistrationFollowUps/>}/>
                                        <Route path="license_requests" element={<AdminRequestedLicenses/>}/>
                                        <Route path="product-examples" element={<ProductExamplesList/>}/>
                                        <Route path="product-examples/:id" element={<ProductExampleView/>}/>
                                        {context.userData!.userGroup! <= EUserGroup.DEVELOPMENT && <>
                                            <Route path="product-examples/:id/edit" element={<ProductExampleEdit/>}/>
                                        </>}
                                        {/* Developer, Admin and SuperAdmin */}

                                        {context.userData!.userGroup! <= EUserGroup.DEVELOPMENT  &&
                                            <>
                                                <Route path="password_generator" element={<ServiceCodeNew/>}/>
                                                <Route path="license_generator" element={<LicenseGenerator/>}/>
                                                <Route path="versions/:link" element={<AdminVersions/>}/>
                                                {/* Only Admin and SuperAdmin */}
                                                {context.userData!.userGroup! <= EUserGroup.ADMIN &&
                                                    <>
                                                        {/* Werkzeuge — keine Einstellungen, deshalb außerhalb von /admin/settings. */}
                                                        <Route path="audit-log" element={<AdminAuditLog/>}/>
                                                        <Route path="geodata-converter" element={<GeodataConverter/>}/>

                                                        {/*
                                                          * Verwaltung: ein Rahmen mit Bereichsnavigation, darin je eine Unterseite.
                                                          * Neue Einstellungsseite = ein Eintrag in settingsSections.ts plus eine Route hier.
                                                          */}
                                                        <Route path="settings" element={<AdminSettingsLayout/>}>
                                                            <Route index element={<SettingsOverview/>}/>
                                                            <Route path="ai" element={<AiSettings/>}/>
                                                            <Route path="ldap" element={<LdapSettings/>}/>
                                                            <Route path="permissions" element={<PermissionGroups/>}/>
                                                            <Route path="geocoding" element={<GeocodingSettings/>}/>
                                                            <Route path="labelconnect" element={<LabelConnectSettings/>}/>
                                                            <Route path="o365" element={<O365Settings/>}/>
                                                            <Route path="filetypes" element={<AdminFileTypes/>}/>
                                                            <Route path="filetypes/:id" element={<FileTypeEdit/>}/>
                                                            <Route path="systems" element={<AdminHostSystems/>}/>
                                                            <Route path="filter-tags" element={<FilterTags/>}/>
                                                            <Route path="terms" element={<AdminTerms/>}/>
                                                        </Route>

                                                        {/*
                                                          * Umleitungen von den früheren Pfaden. Bleiben dauerhaft stehen — gesetzte
                                                          * Lesezeichen und verlinkte Anleitungen sollen weiter funktionieren.
                                                          */}
                                                        <Route path="ldap" element={<Navigate to="/admin/settings/ldap" replace/>}/>
                                                        <Route path="permissions" element={<Navigate to="/admin/settings/permissions" replace/>}/>
                                                        <Route path="geocoding" element={<Navigate to="/admin/settings/geocoding" replace/>}/>
                                                        <Route path="filetypes" element={<Navigate to="/admin/settings/filetypes" replace/>}/>
                                                        <Route path="filetypes/:id" element={<LegacyFileTypeRedirect/>}/>
                                                        <Route path="systems" element={<Navigate to="/admin/settings/systems" replace/>}/>
                                                        <Route path="filterTags" element={<Navigate to="/admin/settings/filter-tags" replace/>}/>
                                                        <Route path="terms" element={<Navigate to="/admin/settings/terms" replace/>}/>
                                                    </>}
                                            </>}
                                    </Route>}
                                <Route path="device-management" element={<DeviceManagement/>}/>
                                {context.userData!.userGroup! <= EUserGroup.OFFICE && <>
                                    <Route path="api-keys" element={<ApiKeys/>}/>
                                    <Route path="service-search" element={<UnifiedSearch/>}/>
                                    {/* Eigener Labelwin-Kalender. Keine Personenauswahl — der Server
                                        leitet die Person aus dem LabelBenutzer des Kontos ab. */}
                                    <Route path="kalender" element={<MyCalendar/>}/>
                                    <Route path="kalkulation/stammdaten" element={<MasterDataEditor/>}/>
                                </>}
                                {context.canOperateCalculator && <>
                                    <Route path="kalkulation" element={<Calculation/>}/>
                                    <Route path="kalkulation/projekt/:projectId" element={<Calculation/>}/>
                                </>}
                                {/* Lesende Ansicht: für alle Angemeldeten (Sichtbarkeit erzwingt der Server). */}
                                <Route path="kalkulation/meine" element={<MyCalculations/>}/>
                                <Route path="*" element={<NotFound/>}/>
                            </Route>
                        </Routes>

                    </> : <>
                        <Routes>
                            <Route path="/support" element={<QuickSupport/>}/>
                            <Route path="/quicksupport" element={<QuickSupport/>}/>
                            <Route path="/signup" element={<SignUp/>}/>
                            <Route path="applications/:link" element={<Applications/>}/>
                            <Route path="applications/:link/:application" element={<ApplicationSingle/>}/>

                            <Route path="*" element={<SignInSide/>}/>
                        </Routes></>
                    }

                </BrowserRouter>
            </>}
        </>
    );
}

export default App;
